export const CLIENT = 18181818181
export const SSO_DOMAIN = 'https://sso.agcoa.in'
export const HAO_DOMAIN = 'https://api.agcoa.in'

export async function defaultResponseHandler(response) {
  if (response.status === 200) {
    const data = await response.json();
    return data;
  } else if (response.status === 401) {
    removeLocal('user');
    return null;
  } else {
    return null;
  }
}

export function getFromLocal(key) {
  let result;
  try {
    let item = JSON.parse(window.localStorage.getItem(key))
    let exp = new Date()
    exp = exp.setDate(exp.getDate())
    if (item.expiry && item.expiry > exp) {
      result = item.value
    } else {
      throw Object.assign(
        new Error("expired"), {code: 402}
      );
    }
  } catch (e) {
    window.localStorage.removeItem(key)
    result = {}
  }
  return result
}

export function storeLocal(key, value) {
  let expiry = new Date()
  expiry.setDate(expiry.getDate() + 7)
  const item = {
    value: value,
    expiry: expiry.getTime()
  }
  window.localStorage.setItem(key, JSON.stringify(item))
}

export function removeLocal(k) {
  window.localStorage.removeItem(k)
}
